<template>
  <v-menu v-model="mostrar" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon> mdi-dots-vertical </v-icon>
      </v-btn>
    </template>
    <v-list>
      <!-- <v-list-item>
        <v-list-item-icon>
          <boton-nueva-plantilla
          modulo="obrassolicitudes"
          :datos="getDatos"
          nombrePlantilla="MEMO SOLICITUD"
          :nombreArchivo="getNombreMemo">
        </boton-nueva-plantilla>
        </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Memo </v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
      <boton-nueva-plantilla
        listItem
        titulo="Memo"
        modulo="obrassolicitudes"
        :datos="getDatos"
        nombrePlantilla="MEMO SOLICITUD"
        :nombreArchivo="getNombreMemo">
      </boton-nueva-plantilla>
      <!-- <v-list-item>
        <v-list-item-icon>
          <boton-nueva-plantilla
          modulo="obrassolicitudes"
          :datos="getDatos"
          nombrePlantilla="OFICIO SOLICITUD"
          :nombreArchivo="getNombreSolicitud">
        </boton-nueva-plantilla>
        </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Oficio </v-list-item-title>
          </v-list-item-content>
      </v-list-item> -->
      <boton-nueva-plantilla
        listItem
        titulo="Oficio"
        modulo="obrassolicitudes"
        :datos="getDatos"
        nombrePlantilla="OFICIO SOLICITUD"
        :nombreArchivo="getNombreSolicitud">
      </boton-nueva-plantilla>
      <excel-solicitud :solicitudObra="solicitudObra" :firma="firma"></excel-solicitud>
      <v-divider></v-divider>
      <v-list-item
      v-if="mixValidaScopesActions(2)"
      @click="editar" link>
        <v-list-item-icon>
          <v-icon> mdi-pencil </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Editar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
      v-if="mixValidaScopesActions(3)"
      @click="borrar" link>
        <v-list-item-icon>
          <v-icon> mdi-delete </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Eliminar </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import ExcelSolicitud from '@/components/exportar/exceles/ExcelSolicitudObra.vue';
import eventBus from '@/helpers/eventBus';
import botonNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/DefaultPlantillaIndividual.vue';
import mixDatosObrasSolicitudes from '@/components/administracion/configuracion/plantillas/generador/mixDatosObrasSolicitudes';

export default {
  name: 'OpcionesSolicitudesObras',
  mixins: [mixDatosObrasSolicitudes],
  props: {
    solicitudObra: {
      type: Object,
      required: true,
    },
    firma: {
      type: Object,
      required: true,
    },
  },
  components: {
    ExcelSolicitud,
    botonNuevaPlantilla,
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    editar() {
      eventBus.$emit('editar-solicitud-obra', this.solicitudObra);
    },
    borrar() {
      eventBus.$emit('eliminar-solicitud-obra', this.solicitudObra);
    },
  },
  computed: {
    getDatos() {
      return this.formatoWordObrasSolicitudes(this.solicitudObra);
    },
    getNombreMemo() {
      return `Memorandum_Solicitud_${this.getDatos.numeroMemorandum}` || 'Memorandum_Solicitud';
    },
    getNombreSolicitud() {
      return `Oficio_Solicitud_${this.getDatos.numeroOficioSolicitud}` || 'Oficio_Solicitud';
    },
  },
};
</script>

<style lang="scss">
</style>
